import { render, staticRenderFns } from "./CuadroMarchaProrrogados.vue?vue&type=template&id=2b2274e1"
import script from "./CuadroMarchaProrrogados.vue?vue&type=script&lang=js"
export * from "./CuadroMarchaProrrogados.vue?vue&type=script&lang=js"
import style0 from "./CuadroMarchaProrrogados.vue?vue&type=style&index=0&id=2b2274e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSimpleTable})
